(() => {
  if (window.MelbourneCatalog) return;

  const timers = new WeakMap();
  const requests = new WeakMap();

  function predictiveContainer(form) {
    const root = form.closest('predictive-search') || form;
    return root.querySelector('[data-melbourne-predictive-container]');
  }

  function closePredictive(form) {
    const input = form.querySelector('[data-melbourne-predictive-input]');
    const results = predictiveContainer(form);
    if (input) input.setAttribute('aria-expanded', 'false');
    if (results) results.hidden = true;
  }

  function updatePredictive(input) {
    const form = input.form;
    const results = form && predictiveContainer(form);
    const query = input.value.trim();
    if (!form || !results) return;
    if (query.length < 2) {
      results.replaceChildren();
      closePredictive(form);
      return;
    }

    const previousTimer = timers.get(form);
    if (previousTimer) window.clearTimeout(previousTimer);
    const previousRequest = requests.get(form);
    if (previousRequest) previousRequest.abort();

    const controller = new AbortController();
    requests.set(form, controller);
    timers.set(form, window.setTimeout(async () => {
      const endpoint = new URL(input.dataset.predictiveUrl || '/search/suggest', window.location.origin);
      endpoint.searchParams.set('q', query);
      endpoint.searchParams.set('section_id', input.dataset.predictiveSection || 'melbourne-predictive-search');
      endpoint.searchParams.set('resources[type]', 'product');
      endpoint.searchParams.set('resources[limit]', input.dataset.predictiveLimit || '6');
      endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');

      try {
        const response = await fetch(endpoint.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Predictive search request failed');
        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const section = documentFragment.querySelector('[data-melbourne-predictive-results]');
        if (!section) {
          results.replaceChildren();
          closePredictive(form);
          return;
        }
        results.innerHTML = section.innerHTML;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') closePredictive(form);
      }
    }, 180));
  }

  document.addEventListener('change', (event) => {
    const control = event.target.closest('[data-melbourne-auto-submit]');
    if (!control) return;
    const form = control.closest('form');
    if (form) form.requestSubmit();
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-melbourne-predictive-input]');
    if (input) updatePredictive(input);
  });

  document.addEventListener('keydown', (event) => {
    const root = event.target.closest('predictive-search') || event.target.closest('form[data-melbourne-search]');
    const input = event.target.closest('[data-melbourne-predictive-input]') || root?.querySelector('[data-melbourne-predictive-input]');
    if (!input) return;
    const form = input.form;
    const results = form && predictiveContainer(form);
    if (!results) return;
    const options = [...results.querySelectorAll('[role="option"] a')];
    if (event.key === 'Escape') {
      if (event.target !== input) input.focus();
      closePredictive(form);
      return;
    }
    if (!options.length) return;
    if (event.target === input && event.key === 'ArrowDown') {
      event.preventDefault();
      options[0].focus();
      return;
    }
    if (event.target.closest('[role="option"]')) {
      const currentIndex = options.indexOf(event.target.closest('[role="option"]').querySelector('a'));
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        options[Math.min(currentIndex + 1, options.length - 1)].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (currentIndex <= 0) input.focus();
        else options[currentIndex - 1].focus();
      }
    }
  });

  document.addEventListener('focusout', (event) => {
    const root = event.target.closest('predictive-search');
    const form = root?.querySelector('form[data-melbourne-search]') || event.target.closest('form[data-melbourne-search]');
    if (!form) return;
    const focusRoot = root || form;
    window.setTimeout(() => {
      if (!focusRoot.contains(document.activeElement)) closePredictive(form);
    }, 0);
  });

  window.MelbourneCatalog = { updatePredictive, closePredictive };
})();

